module.exports = __webpack_public_path__ + "img/pic9.c650a8da.png";